import dayjs                     from "dayjs";
import utc                       from "dayjs/plugin/utc";
import Toast                     from "_common/toast";
import { isInsideThirdPartyApp } from "_root/thirdParty";
import { thirdPartyUiConfig }    from "_config/index";
import { SITE_URL }              from "_config/index";

export const isNumeric = val => {
	return /^-?\d+$/.test ( val );
};

export const shortenNumber = value => {
	let newValue = value;

	if ( value >= 1000000 ) newValue = parseFloat ( ( value / 1000000 ).toFixed ( 1 ) ) + "M";
	else if ( value >= 1000 ) {
		newValue = parseFloat ( ( value / 1000 ).toFixed ( 1 ) ) + "K";
	}

	return newValue;
};

export const getSrc = ( isFrom, id, feedRoute ) => {

	let shareLink;

	if ( !feedRoute )
		shareLink = `${ getBaseURL () }/${ isFrom }/${ id }`;
	else shareLink = `${ getBaseURL () }${ feedRoute }`;

	return shareLink;
};

export const createQueryParams = params => {
	let query = "";

	for ( const param of Object.keys ( params ) ) {
		query += `&${ param }=${ params[param] }`;
	}

	return query ? `?${ query }` : "";
};

export const getBaseURL = () => {
	if ( !process.browser )
		return SITE_URL;

	return window.location.origin;
};

export const formatDateTimeToIST = currentTime => {
	var currentOffset = currentTime.getTimezoneOffset ();

	var ISTOffset = 330; // IST offset UTC +5:30

	var ISTTime = new Date ( currentTime.getTime () + ( ISTOffset + currentOffset )*60000 );

	return ISTTime;
};

export const formatCombinedFeedData = ( feedData, broadcastData ) => {
	if ( !feedData || !broadcastData )
		return [];

	if ( broadcastData.length ) {
		const formattedBroadcastData = mapBroadcastToPostFeedData ( broadcastData );

		return [ feedData, formattedBroadcastData ].reduce ( ( r, a ) => ( a.forEach ( ( a, i ) => ( r[i] = r[i] || [] ).push ( a ) ), r ), [] ).reduce ( ( a, b ) => a.concat ( b ) );
	}

	return feedData;
};

export function cleanTitle ( title ) {
	const regex = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

	/* eslint-disable */
	title        = title.replace ( regex, "" );
	title        = title.replace ( /[.,\/#!$%\^&\*;'|?@:{}="\-_`~()\\]/g, "" );
    /* eslint-enable */

	let lastChar = title.charAt ( title.length - 1 );

	while ( lastChar === "?" || lastChar === " " ) {
		title    = title.substr ( 0, title.length - 1 );
		lastChar = title.charAt ( title.length - 1 );
	}
	title = title.split ( " " ).join ( "-" );

	return title || "";
}

export const copyToClipboard = ele => {
	let CLIPBOARD_API = "clipboard";

	if ( checkForFeatureSupport ( CLIPBOARD_API ) ) {
		const data = ele;

		navigator.clipboard.writeText ( data ).then ( function () {
			Toast.info ( "Copied to clipboard" );
		} );
	} else {
		const copyText = document.getElementById ( ele );

		copyText.select ();
		document.execCommand ( "Copy" );

		Toast.info ( "Copied to clipboard" );
	}
};

export const getBroadcastSessionRoute = session => {
	let href = "",
		as = "";

	if ( session ) {
		let gameName;
		const { sessionType, game } = session;

		if ( session.sessionType === "gaming" ) {
			if ( game && session.game.name ) {
				gameName = cleanTitle ( session.game.name );
			} else {
				gameName = "gaming";
			}
		}

		href = "/live-video/[session]";
		as   = sessionType === "gaming" ? `live-video/${ gameName }-live-stream` : "live-video/live-ball-by-ball-commentary";
	}

	return {
		sessionHref : href,
		sessionAs   : `/${ as }`,
		shareUrl    : as
	};
};

export const convert_m3u8_todownloadformat = file => {
	let pos       = file.indexOf ( "rooter.io/" ) + 9;
	let temp_link = file.substr ( 0, pos ) + "/download" + file.substr ( pos );

	pos               = temp_link.indexOf ( "m3u8" );
	let download_link = temp_link.substr ( 0, pos ) + "mp4" + temp_link.substr ( pos + 4 );

	return download_link;
};

export const checkForFeatureSupport = feature => {
	switch ( feature ) {
		case "clipboard": {
			if ( navigator.clipboard ) {
				return true;
			}

			return false;
		}

		default:
			break;
	}
};

export function checkForAppleDevice () {
	if ( !process.browser ) return;
	const isSafari = /^((?!chrome|android).)*safari/i.test ( navigator.userAgent );
	const iOS      = ( /iPad|iPhone|iPod/.test ( navigator.userAgent ) && !window.MSStream ) || isSafari;

	return iOS;
}

export const getResponsiveImage = image => {
	if ( !image || image.indexOf ( "/incoming/" ) === -1 )
		return image;

	let image_type;
	let dpr         = window.devicePixelRatio;
	const extension = "webp";

	if ( window.innerWidth >= "600" ) {
		image_type = `xxhdpi.${ extension }`;
	} else if ( dpr <= 1.5 ) {
		image_type = `mdpi.${ extension }`;
	} else if ( dpr <= 2 ) {
		image_type = `hdpi.${ extension }`;
	} else if ( dpr <= 3 ) {
		image_type = `hdpi.${ extension }`;
	} else if ( dpr <= 4 ) {
		image_type = `xhdpi.${ extension }`;
	} else {
		image_type = `xxhdpi.${ extension }`;
	}
	let arr    = image.split ( "/" );
	let imgSrc = arr[arr.length - 1];
	let pos    = imgSrc.indexOf ( "." );

	imgSrc = imgSrc.substr ( 0, pos );
	arr.splice ( arr.length - 2, 2, imgSrc, image_type );
	imgSrc = arr.join ( "/" );

	return imgSrc;
};

export function checkForFirefox () {
	const isFirefox = typeof InstallTrigger !== "undefined";

	return isFirefox;
}

export const getServerResponsiveImage = ( image, type = "mdpi" ) => {
	if ( !image || image.indexOf ( "/incoming/" ) === -1 )
		return image;

	let format     = "webp";
	let image_type = `${ type }.${ format }`;
	let arr        = image.split ( "/" );
	let imgSrc     = arr[arr.length - 1];
	let pos        = imgSrc.indexOf ( "." );

	imgSrc = imgSrc.substr ( 0, pos );
	arr.splice ( arr.length - 2, 2, imgSrc, image_type );
	imgSrc = arr.join ( "/" );

	return imgSrc;
};

export const getOptImage = ( image, size ) => {
	return process.browser && !size ? getResponsiveImage ( image ) : getServerResponsiveImage ( image, size );
};

dayjs.extend ( utc );
export const mapBroadcastToPostFeedData = broadcasts => {

	if ( broadcasts && broadcasts.length > 0 ) {
		const formattedBroadcasts = broadcasts.map ( item => {
			let postFeedObj = {
				id           : item.id,
				actorDetails : {
					...item.broadcaster.sportsFan
				},
				tags     : [],
				feedType : [ "BROADCAST" ],
				title    : item.sessionInfo,
				views    : item.views,
				media    : [
					{
						mediaType : "IMAGE",
						href      : item.thumbnail ? item.thumbnail : item.game && item.game.banner ? item.game.banner : item.broadcaster.sportsFan.photo
					}
				],
				reactions: [
					{
						reaction : "AGREE",
						count    : item.totalReactions
					}
				],
				createdAt          : item.startTimeUTC || null,
				broadcastGame      : item.game,
				broadcastMatch     : item.match || null,
				broadcastIsLive    : !!( !item.endTimeUTC && !item.endedAt ),
				broadcastMediaType : item.sessionType === "gaming" ? "gaming" : item.mediaType,
				commentCount       : item.totalComments,
				sharesCount        : item.totalShares,
				isLeaderBoardLive  : item.isLeaderBoardLive,
				isPwf              : item.playWithFriends,
				isLive             : !item.endTimeUTC,
				liveViews          : item.liveViews
			};

			return postFeedObj;
		} );

		return formattedBroadcasts;
	}

	return broadcasts;
};

export const filterEmptyObjects = ( key, arr ) => {
	if ( arr ) {
		return arr.filter ( item => {
			if ( key ) {
				if ( item && item[key] ) return item;
			} else {
				if ( item ) return item;
			}
		} );
	}

	return [];
};

export const thirdPartyUiCheck = uiKey => {
	const thirdPartyApp = isInsideThirdPartyApp ();

	if ( thirdPartyApp ) {
		if ( thirdPartyUiConfig[uiKey][thirdPartyApp] === true ) {
			return true;
		}

		return false;
	}

	return true;
};

export const shareToExternal = ( shareLinkData, feedType ) => {
	let source       = `${ getBaseURL () }${ shareLinkData.path }${ feedType === "video" || feedType === "gaming" ? shareLinkData.params : "" }`;
	const encodedSrc = encodeURIComponent ( source );
	const webSource  = `whatsapp://send?text=${ encodedSrc }`;
	let a            = document.createElement ( "a" );

	a.href   = webSource;
	a.target = "_blank";
	a.click ();
};

export const getFormattedPreviousPathObject = previousPath => {
	if ( previousPath ) {
		let queryParams = previousPath.query && previousPath.query.locale && previousPath.query.locale !== "en" ? `?locale=${ previousPath.query.locale }` : "";

		if ( previousPath.query && previousPath.query.id && previousPath.query.match_tab )
			queryParams = queryParams ? `${ queryParams }&id=${ previousPath.query.id }` : `?id=${ previousPath.query.id }`;

		const route = previousPath.href;
		const href  = `${ previousPath.href }${ queryParams }`;
		const as    = `${ previousPath.as }${ queryParams }`;

		return {
			href,
			as,
			route
		};
	}

	return false;
};

export const isPageRoute = ( { router, page } ) => {
	switch ( page ) {
		case "home":
			return router.pathname === "/";

		case "live":
			return router.pathname === "/live";

		case "profile":
			return router.pathname === "/profile/[id]";

		case "stream":
			return router.pathname === "/stream/[id]";

		case "studio":
			return router.pathname === "/studio";

		case "video":
			return router.pathname === "/video/[id]";

		case "download":
			return router.pathname === "/download";

		case "modfeed":
			return router.pathname === "/modfeed";

		case "mods":
			return router.pathname === "/mods/[session]";

		case "activate":
			return router.pathname === "/activate";

		case "growth-dashboard":
			return router.pathname === "/growth-dashboard";

		case "top-creators":
			return router.pathname === "/top-creators";

		case "notifications":
			return router.pathname === "/notifications";

		case "results":
			return router.pathname.includes ( "/results" );

		case "search-suggestions":
			return router.pathname.includes ( "/search-suggestions" );

	}
};

export const removeJSSLogs = () => {
	/* eslint-disable */
    if ( typeof window === "undefined" ) {
        const originalWarn = console.warn;

        console.warn = ( ...args ) => {
            if (
                args[0] !==
        "Warning: [JSS] Rule is not linked. Missing sheet option \"link: true\"."
            ) {
                originalWarn ( ...args );
            }
        };
    }
    /* eslint-enable */
};
